(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rysn-landing"] && !Shopify.designMode) return;
  try {
    
  function initialiseRysnLanding(root) {
    root.querySelectorAll('.rysn-menu').forEach((menu) => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => { menu.open = false; });
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          menu.open = false;
          menu.querySelector('summary').focus();
        }
      });
    });
    const feedback = root.querySelector('.rysn-form__message');
    if (feedback && window.location.hash === '#RysnSignupForm') {
      feedback.focus();
    }
  }
  document.querySelectorAll('.rysn-landing').forEach(initialiseRysnLanding);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.rysn-landing').forEach(initialiseRysnLanding);
  });

  } catch(e) { console.error(e); }
})();
})();
